<h4>{{moTitle}}</h4>

@for (option of options; track option) {
  <button
    [ngClass]="getOptionClass(option) + ' btn btn-answer'"
    (click)="selectOption(option)" [disabled]="!!selectedOption || isDiscardedOption(option)">
    <app-content-viewer [content]="transformOption(option)"
      [ngClass]="isDiscardedOption(option) ? 'discarded-option' : ''"
    ></app-content-viewer>
  </button>
}
